import { GridLegacy as Grid, Typography, useTheme } from "@mui/material";
import { useCallback } from "react";
import { prettyPrintDateTime } from "util/dates";

export interface ScreenshotItem {
  src: string;
  createdAt: string;
}

export interface ScreenshotsTabProps {
  screenshotSrcs: ScreenshotItem[];
}

export function ScreenshotsTab({ screenshotSrcs }: ScreenshotsTabProps) {
  const theme = useTheme();
  const handleImageClick = useCallback((src: string) => window.open(src, "_blank"), []);

  if (screenshotSrcs.length === 0) {
    return <Typography color="text.secondary">No screenshots for this job.</Typography>;
  }

  return (
    <Grid container spacing={1}>
      {screenshotSrcs.map(({ createdAt, src }) => (
        <Grid item key={src} display="flex" flexDirection="column" alignItems="center">
          <img
            style={{
              width: 200,
              height: 200,
              borderRadius: 4,
              marginTop: theme.spacing(2),
              marginLeft: theme.spacing(1),
              marginRight: theme.spacing(2),
              cursor: "pointer",
            }}
            src={src}
            alt={`Geppetto error screenshot ${src}`}
            onClick={() => handleImageClick(src)}
          />
          <Typography variant="caption" sx={{ marginTop: theme.spacing(1), textAlign: "center" }}>
            {prettyPrintDateTime(createdAt)}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
